import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { 
  LoginSocialFacebook, 
  LoginSocialGoogle,
} from 'reactjs-social-login';

import SignInForm from './components'
import Button from '../../UI/Button'
import Preloader from '../../UI/Preloader'
import Logo from '../../../assets/logo.svg'
import { FACEBOOK_APP_ID } from '../../../constants'

import * as actions from './actions'
import { GoogleLogin } from '@react-oauth/google';
import { GoogleButton } from '../GoogleButton';

// const customStyles = {
//   content : {
//     top                   : '50%',
//     left                  : '50%',
//     right                 : 'auto',
//     bottom                : 'auto',
//     marginRight           : '-50%',
//     transform             : 'translate(-50%, -50%)'
//   }
// }

//Modal.setAppElement('#root')

class SignIn extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      modalIsOpen: false,
      loginGoogleLoading: null,
      loginFacebookLoading: null,
      loginAppleLoading: null
    }
  }

  responseFacebook = ({ data }) => {
    console.log(data)
    const { sendFacebookTokenId } = this.props
    sendFacebookTokenId(data.accessToken)
  }

  responseGoogleSuccess = (response) => {
    const { sendGoogleTokenId } = this.props
    sendGoogleTokenId(response.credential)
  }
  responseGoogleFailure = response => {}

  onAppleSignIn = async () => {
    const { sendAppleTokenId } = this.props
    sendAppleTokenId()
  }

  render() {
    const {
      loginGoogleLoading,
      loginFacebookLoading,
      loginAppleLoading
    } = this.state
    return (
      <main className="layout">
        <div className="auth">
          <div className="auth_placeholder">
            <img src={Logo} alt="logo" className="logo auth_logo" />
            <p className="auth_intro">Log in using your TimeFlip account</p>
            <div className="auth_social_buttons flex">
              <LoginSocialFacebook
                appId={FACEBOOK_APP_ID}
                fields="name,email"
                redirect_uri={process.env.REACT_APP_APP_URL + 'auth'}
                onResolve={this.responseFacebook}
                onReject={e => console.error(e)}
                isOnlyGetToken
              >
                <Button facebook>
                  Sign In with Facebook
                  {loginFacebookLoading && (
                    <Preloader
                      mini
                      style={{ position: 'absolute', right: '20px' }}
                    />
                  )}
                </Button>
              </LoginSocialFacebook>
              <GoogleButton onSuccess={this.responseGoogleSuccess} onError={this.responseGoogleFailure}>
                Sign In with Google
                {loginGoogleLoading && (
                  <Preloader
                    mini
                    style={{ position: 'absolute', right: '20px' }}
                  />
                )}
              </GoogleButton>
              <Button onClick={this.onAppleSignIn} apple>
                Sign In with Apple
                {loginAppleLoading && (
                  <Preloader
                    mini
                    style={{ position: 'absolute', right: '20px' }}
                  />
                )}
              </Button>
            </div>
            <span className="or">or</span>
            <SignInForm />
            <Link to="/forgot-password">Forgot your password?</Link>
            <p style={{ marginTop: 'auto' }}>
              Don’t have an account?&nbsp;
              <Link to="/register">Sign up</Link>
            </p>
          </div>
        </div>
      </main>
    )
  }
}

SignIn.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.node])
}

const mapStateToProps = state => ({})

const mapDispatchToProps = dispatch => ({
  sendGoogleTokenId: token => dispatch(actions.sendGoogleTokenId(token)),
  sendFacebookTokenId: token => dispatch(actions.sendFacebookTokenId(token)),
  sendAppleTokenId: () => dispatch(actions.sendAppleTokenId())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignIn)
